import { ready } from 'brei-project-utils';
import { loading } from './modules/loading';
import { animator } from './modules/animator';
import { header } from './modules/header';
import { trailer } from './modules/trailer';
// import { intro } from './modules/intro';
import { podcast } from './modules/podcast';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const main = {

	elem: {
	},

	init() {

		loading.init();
		animator.init();
		header.init();
		trailer.init();
		// intro.init();
		podcast.init();

	}

};

ready(function () {
	main.init();
});
